<div>
  <section class="form-block-container">
    @if (showVin) {
      <label class="col-2"><strong>{{''|i18n:'VIN'}}</strong></label>
    }
    <label class="col-2"><strong>{{''|i18n:'model'}}</strong></label>
    @if (!showVin) {
      <label class="col-2"><strong>{{''|i18n:'contract-type'}}</strong></label>
    }
    @if (showVin) {
      <label class="col-1"><strong>{{''|i18n:'mileage'}}</strong></label>
    }
    @if (showVin) {
      <label class="col-1"><strong>{{''| i18n:'mileage-date'}}</strong></label>
    }
    <label class="col-2"><strong>{{''|i18n:'result'}}</strong></label>
    <label class="col-1"><strong>{{''|i18n:'12-months'}}</strong></label>
    <label class="col-1"><strong>{{''|i18n:'24-months'}}</strong></label>
    <label class="col-1"><strong>{{''|i18n:'36-months'}}</strong></label>
    <label class="col-1"><strong>{{''|i18n:'48-months'}}</strong></label>
  </section>
  @for (estimationResult of estimationResults; track estimationResult) {
    <section>
      @if (showVin) {
        <label class="col-2">{{ estimationResult.vin}}</label>
      }
      <label class="col-2">{{estimationResult.model}}</label>
      @if (!showVin) {
        <label class="col-2">{{estimationResult.contractType}}</label>
      }
      @if (showVin) {
        <label class="col-1">{{estimationResult.mileage}}</label>
      }
      @if (showVin) {
        <label class="col-1">{{estimationResult.mileageDate}}</label>
      }
      <label class="col-2" [style]="resultClass(estimationResult.message)">{{'' | i18n:result(estimationResult)}}</label>
      <label class="col-1">{{euro(estimationResult.twelveMonthsPremium)}}</label>
      <label class="col-1">{{euro(estimationResult.twentyFourMonthsPremium)}}</label>
      <label class="col-1">{{euro(estimationResult.thirtySixMonthsPremium)}}</label>
      <label class="col-1">{{euro(estimationResult.fortyEightMonthsPremium)}}</label>
    </section>
  }
</div>
